import styled from 'styled-components'
import { LIGHT_LAVENDER, LIGHT_BLUE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const TimerRow = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const RefreshButton = (styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:disabled {
    cursor: not-allowed;
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TimerBadge = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  background-color: ${LIGHT_LAVENDER};
  border: 1px solid ${LIGHT_BLUE};
  border-radius: 8px;
  padding: 4px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CountdownText = (styled.span`
  font-family: ${INTER.semiBold};
  font-size: 12px;
  font-weight: 600;
  color: black;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
